<template>
  <WeekTimeManager />
</template>

<script>
// TODO: Delete?

import WeekTimeManager from '@/components/CalendarPage/WeekTimeManager'

export default {
  name: "ManageWeekSubpage",
  components: {
    WeekTimeManager
  }
};
</script>
